<template>
  <div class="BusinessLicense">
    <div class="TopTitle">
      首营信息
    </div>
    <div class="TopLine"></div>
    <div class="CompayName">
      归创通桥医疗科技股份有限公司
    </div>
    <FromComponents :FronSY="FronSY"></FromComponents>
  </div>
</template>

<script>
import FromComponents from '../../../components/fromComponents/fromComponents.vue'
import FronSY from '../FromData/fromData'
export default {
  components: {
    FromComponents
  },
  props: {},
  data() {
    return {
      FronSY: []
    }
  },
  created() { },
  mounted() {
    this.FronSY = JSON.parse(JSON.stringify(FronSY))
  },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.BusinessLicense {
  width: 100%;
  height: 100%;
  position: absolute;
  .TopTitle {
    font-size: 16px;
    color: #16181a;
    font-weight: 500;
    margin: 24px;
  }
  .TopLine {
    height: 1px;
    width: 890px;
    background-color: #ebedf0;
    top: 20px;
    margin: 0 auto;
  }
  .CompayName {
    height: 28px;
    width: 100%;
    // border: 1px solid red;
    color: #00266d;
    margin-top: 25px;
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
    text-align: center;
    overflow: hidden;
  }
  .CompayName img:nth-child(1) {
  }
}
</style>